import {css} from "lit-element/lit-element.js";
export default css`
.selector {
  overflow: scroll;
  padding-bottom: 10px;
}
.selector .inner {
  white-space: nowrap;
}
.selector .inner .thumb {
  display: inline-block;
}
.selector .inner .thumb img {
  cursor: pointer;
  width: 20vmin;
  height: 20vmin;
  max-width: 200px;
  max-height: 200px;
  margin: 10px;
  box-shadow: 0 0 10px #888;
}
@media only screen and (max-device-width: 800px) and (orientation: portrait) {
  .selector .inner .thumb img {
    width: 33vmin;
    height: 33vmin;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL3RtcC9iaWdfdmlzaW9uL2JpZ192aXNpb24vdG9vbHMvbGl0X2RlbW8vc3JjL2NvbXBvbmVudHMiLCJzb3VyY2VzIjpbImltYWdlLWNhcm91c2VsLnNjc3MiLCIuLi9zdHlsZS9taXhpbnMuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQTtFQUNFO0VBQ0E7O0FBRUE7RUFDRTs7QUFFQTtFQUNFOztBQUVBO0VBQ0U7RUFFQTtFQUNBO0VBQ0E7RUFDQTtFQU9BO0VBRUE7O0FDdkJOO0VEUUk7SUFTSTtJQUNBIiwic291cmNlc0NvbnRlbnQiOlsiQGltcG9ydCAnLi4vc3R5bGUvbWl4aW5zJztcblxuLnNlbGVjdG9yIHtcbiAgb3ZlcmZsb3c6IHNjcm9sbDtcbiAgcGFkZGluZy1ib3R0b206IDEwcHg7IC8vIE9TIFggc2Nyb2xsIGJhclxuXG4gIC5pbm5lciB7XG4gICAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcblxuICAgIC50aHVtYiB7XG4gICAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG5cbiAgICAgIGltZyB7XG4gICAgICAgIGN1cnNvcjogcG9pbnRlcjtcblxuICAgICAgICB3aWR0aDogMjB2bWluO1xuICAgICAgICBoZWlnaHQ6IDIwdm1pbjtcbiAgICAgICAgbWF4LXdpZHRoOiAyMDBweDtcbiAgICAgICAgbWF4LWhlaWdodDogMjAwcHg7XG5cbiAgICAgICAgQGluY2x1ZGUgcGhvbmUtcG9ydHJhaXQge1xuICAgICAgICAgIHdpZHRoOiAzM3ZtaW47XG4gICAgICAgICAgaGVpZ2h0OiAzM3ZtaW47XG4gICAgICAgIH1cblxuICAgICAgICBtYXJnaW46IDEwcHg7XG5cbiAgICAgICAgYm94LXNoYWRvdzogMCAwIDEwcHggIzg4ODtcbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cbiIsIi8vIFVzZWZ1bCBtaXhpbnMuXG5cbi8vIFRvIHdyYXAgc3R5bGVzIHRoYXQgc2hvdWxkIG9ubHkgdHJpZ2dlciBmb3IgcGhvbmVzIGluIHBvcnRyYWl0IG1vZGUuXG5AbWl4aW4gcGhvbmUtcG9ydHJhaXQge1xuICBAbWVkaWEgb25seSBzY3JlZW4gYW5kIChtYXgtZGV2aWNlLXdpZHRoOiA4MDBweCkgYW5kIChvcmllbnRhdGlvbjogcG9ydHJhaXQpIHtcbiAgICBAY29udGVudDtcbiAgfVxufVxuIl19 */`;
